module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("产品&服务")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3dcbf16d"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_4.vue
// module id = 776
// module chunks = 1